import { compareMoney } from 'lib/maths/mathUtils'

/**
 * Compare the item total cost with the budget at the cent precision
 * This rounds up the IEEE-754 JS double precision problem
 */
export function isOverBudget(total: number, budget: number): boolean {
  return compareMoney(total, budget) > 0
}

export function isWithinBudget(total: number, budget: number): boolean {
  return compareMoney(total, budget) <= 0
}
